import { render } from "./DDoSProtection.vue?vue&type=template&id=cc7d7e44"
import script from "./DDoSProtection.vue?vue&type=script&lang=js"
export * from "./DDoSProtection.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__